var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "rb-facets-cta rb-btn rb-btn--black-outline",
      on: {
        mouseover: function ($event) {
          _vm.isHover = true
        },
        mouseleave: function ($event) {
          _vm.isHover = false
        },
        click: function ($event) {
          return _vm.$emit("openPanel")
        },
      },
    },
    [
      _c("rb-lazy-icon", { attrs: { icon: _vm.icon } }),
      _vm._v("\n  " + _vm._s(_vm.$t("plp.all_filters")) + "\n  "),
      _vm.totalProducts > 0
        ? [_vm._v(" (" + _vm._s(_vm.totalProducts) + ") ")]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }